import React from 'react';
import { Section } from '../components/Section';
import { Card } from '../components/Card';
import { Shield, Lock, Server, FileCheck } from 'lucide-react';
export function Security() {
  return <div className="pt-20" data-id="element-622">
      <Section className="bg-gradient-to-br from-[#EEF2FF] to-white text-center" data-id="element-623">
        <div className="container mx-auto px-4" data-id="element-624">
          <Shield className="w-16 h-16 text-[#6366F1] mx-auto mb-6" data-id="element-625" />
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-626">
            Your Data is Secure
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-627">
            Cart Tracker is built with security and privacy as top priorities.
          </p>
        </div>
      </Section>

      <Section className="bg-white" data-id="element-628">
        <div className="container mx-auto px-4 md:px-6" data-id="element-629">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-630">
            <Card className="p-8" data-id="element-631">
              <Lock className="w-10 h-10 text-[#6366F1] mb-4" data-id="element-632" />
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-633">
                End-to-End Encryption
              </h3>
              <p className="text-gray-600" data-id="element-634">
                All cart data is encrypted in transit using TLS 1.3 and stored
                securely with AES-256 encryption.
              </p>
            </Card>
            <Card className="p-8" data-id="element-635">
              <Server className="w-10 h-10 text-[#6366F1] mb-4" data-id="element-636" />
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-637">
                No Data Storage
              </h3>
              <p className="text-gray-600" data-id="element-638">
                Cart data is processed in real-time and never stored on our
                servers. Your information stays with you.
              </p>
            </Card>
            <Card className="p-8" data-id="element-639">
              <FileCheck className="w-10 h-10 text-[#6366F1] mb-4" data-id="element-640" />
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-641">
                Privacy Compliant
              </h3>
              <p className="text-gray-600" data-id="element-642">
                Fully compliant with GDPR, CCPA, and other privacy regulations.
                We never sell or share your data.
              </p>
            </Card>
            <Card className="p-8" data-id="element-643">
              <Shield className="w-10 h-10 text-[#6366F1] mb-4" data-id="element-644" />
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-645">
                Regular Security Audits
              </h3>
              <p className="text-gray-600" data-id="element-646">
                Our extension undergoes regular security audits and penetration
                testing to ensure maximum protection.
              </p>
            </Card>
          </div>
        </div>
      </Section>
    </div>;
}